<template>
    <div>
    <p>This is a disk image with a signed and notarized GanttProject application. Java Runtime is bundled. You don't need to download anything else.</p>

    <div class="p-3">
        <strong>GanttProject {{ version }} for macOS</strong>
        <div class="help-text pb-3">Built on {{ releaseDate }}</div>
        <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/mac`">Download [{{ size }}]</a>
    </div>

      <h3>Maintenance updates</h3>
      <p>Maintenance updates to version {{ version }} will be delivered through our Update Channel. Please leave Auto-Update option in the settings switched on to let GanttProject to check for updates from time to time. When a new update becomes available, you will be able to review it and choose to install or skip.</p>

    </div>
</template>

<script>
    export default {
        name: "DownloadMac30",
        props: {
            releaseDate: String,
            size: String,
            version: String,
            virustotalHash: String
        }
    }
</script>

<style scoped>

</style>
